export default "__VITE_ASSET__68a5c615__"